var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5 1.833A3.17 3.17 0 0 0 5.333 5c0 1.713 1.34 3.1 3.087 3.16a.5.5 0 0 1 .146 0h.047A3.16 3.16 0 0 0 11.666 5 3.17 3.17 0 0 0 8.5 1.833M11.887 9.933c-1.86-1.24-4.894-1.24-6.767 0-.847.567-1.313 1.333-1.313 2.153s.466 1.58 1.306 2.14c.934.627 2.16.94 3.387.94s2.453-.313 3.387-.94c.84-.566 1.306-1.326 1.306-2.153-.006-.82-.466-1.58-1.306-2.14"
  })));
};
export default SvgIconUser;